const userApplicationServiceDictionary = {
  getApplicationFormData: (token: string, applicationId: string) =>
    `api/v1/user-application/fetch?applicationId=${applicationId}`,

  getApplication: (token: string, status?: string) =>
    status
      ? `api/v1/user-application/fetch?status=${status}`
      : `api/v1/user-application/fetch`,
};

export default userApplicationServiceDictionary;
